"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "clearCache", {
    enumerable: true,
    get: function() {
        return clearCache;
    }
});
const _config = require("@lage-run/config");
const _workspacetools = require("workspace-tools");
const _cache = require("@lage-run/cache");
async function clearCache(options) {
    const { logger, cwd } = options;
    const config = await (0, _config.getConfig)(cwd);
    const workspaceRoot = (0, _workspacetools.getWorkspaceRoot)(cwd);
    const concurrency = (0, _config.getConcurrency)(options.concurrency, config.concurrency);
    if (!workspaceRoot) {
        return;
    }
    const cacheProvider = new _cache.BackfillCacheProvider({
        root: cwd,
        cacheOptions: config.cacheOptions,
        logger
    });
    // eslint-disable-next-line no-console
    console.log("Clearing Cache");
    cacheProvider.clear(concurrency);
    // eslint-disable-next-line no-console
    console.log("Cache Cleared");
}
